


























import { defineComponent, computed } from "@vue/composition-api";

export default defineComponent({
  props: {
    cargando: Boolean,
    campos: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      // required: true,
    },
  },
  setup(props, { emit }) {
    const headers = computed(() =>
      props.campos?.map((c: any) => ({
        ...c.tableConfig,
        text: c.titulo,
        value: c.nombre,
        class: "sticky-header text-button font-weight-bold",
      }))
    );

    const seleccionar = (item) => {
      emit("seleccionar", item);
    };

    return {
      headers,
      seleccionar,
    };
  },
});
